import React, { Component } from 'react';

class PrivacyPolicy extends Component {

  render() {
    return (
      <div style={{ padding: '20px', color: 'white'}}>
        <h2>Epoch - 隐私政策</h2>
        <p>
          Epoch 是一个音乐工具箱，他在 iOS 平台上提供了吉他，尤克里里，贝斯调音器功能，旨在为用户提供专业的调音器，帮助用户培养良好的练琴习惯。
          <br/>
          <br/>
          这个隐私政策作用 Epoch iOS app 本身
          <br/>
          <br/>
          <b style={{ fontSize: 18 }}>关于 Epoch 的数据收集</b>
          <br/>
          <br/>
          Epoch 非常注重用户隐私，Epoch 不会收集任何关于用户隐私的数据，他只会在 app 闪退的时候记录 iOS 系统版本和错误信息并且发送给开发者，这是为了让开发者更好的修复问题，提供良好的用户体验，除此之外，Epoch 的所有练琴数据都存在本地。
          <br/>
          <br/>
          Epoch 需要使用麦克风，但是他绝不会在用户不知情的情况下在后台录音并上传数据，麦克风只会被用来分析乐器发出声音的音高从而提供调音器的相关功能。
          <br/>
          <br/>
          Epoch 使用第三方的数据分析和崩溃报告平台: Firebase，您需要同意 Firebase 的隐私政策，详情请看：<a href="https://policies.google.com/privacy">https://policies.google.com/privacy</a>
          <br/>
          <br/>
          <b style={{ fontSize: 18 }}>隐私政策更新</b>
          <br/>
          <br/>
          我们会不定期更新隐私政策，所以我们建议您周期性的阅读这个页面，如果有内容更新，我们会写到这个页面里，所有的改动将立即生效。
          <br/>
          <br/>
          <b style={{ fontSize: 18 }}>联系我们</b>
          <br/>
          <br/>
          如果对于隐私政策有任何问题，请联系我们 <a href="mailto:panlei106@gmail.com">panlei106@gmail.com.</a>
          <br/>
          <br/>
          谢谢您选择 Epoch!
          <br/>
          Epoch 团队
        </p>

        <h2 style={{ marginTop: 100 }}>Epoch - Privacy Policy</h2>
        <p>
          Epoch is an Music Toolkit for tuning Guitar, Ukulele, Bass on iOS, it aims to provide a professional tuner app for guitar learners and help learners to foster the habit of practicing guitar everyday.
          <br/>
          <br/>
          This privacy policy applies to the iOS main app itself, its embedded frameworks and app extensions
          <br/>
          <br/>
          <b style={{ fontSize: 18 }}>Data Collected by Epoch</b>
          <br/>
          <br/>
          Epoch takes its users' privacy very seriously, it will never collect any of your private information, it only collect iOS version and error log and send it to developer when app crash, this information can help developer to fix issues and provide better user experience
          <br/>
          <br/>
          Epoch need microphone to provide tuner functions, it will never record audio and upload audio file in the background without you awareness, The microphone permission epoch asked for is merely used for recording audio and analyse it to measure the pitch of the sound.
          <br/>
          <br/>
          Epoch use third-party analysis and crash report tool called Firebase, you need to agree with the privacy policy provided by Firebase, please refer to: <a href="https://policies.google.com/privacy">https://policies.google.com/privacy</a>
          <br/>
          <br/>
          <b style={{ fontSize: 18 }}>Changes to This Privacy Policy</b>
          <br/>
          <br/>
          We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.
          <br/>
          <br/>
          <b style={{ fontSize: 18 }}>Contact Us</b>
          <br/>
          <br/>
          If you have any questions or suggestions about Privacy Policy, do not hesitate to contact us at <a href="mailto:panlei106@gmail.com">panlei106@gmail.com.</a>
          <br/>
          <br/>
          Thanks for choosing Epoch!
          <br/>
          Epoch Team
        </p>
      </div>
    );
  }
}

export default PrivacyPolicy